export enum IbcShipTypeEnum {
    Unknown,
    One,
    Two,
    TwoK,
    Three,
}
